<mat-form-field class="full-width typeselect">
  <input type="text" aria-label="Queue" matInput [formControl]="queueControl" [matAutocomplete]="auto" [(ngModel)]="queueModel" name="queuename" (ngModelChange)="updateQueueArn($event)">
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option *ngFor="let queue of filteredOptions | async" [value]="queue.QueueName">
      {{queue.QueueName}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
